import React from 'react';
import { m } from 'framer-motion';
import '../styles/cta.css';

const CTASection = ({ onOpenSignup }) => {
  return (
    <section className="cta">
      <div className="cta-bg"></div>
      <div className="container cta-content">
        <h2>Ready to Find Your Next Ride?</h2>
        <p>
          Join thousands of Zambians buying and selling vehicles smarter every day. 
          Download ZamWheelz. It's free.
        </p>
        <div className="cta-buttons">
          <m.button
            className="btn-cta-primary"
            onClick={onOpenSignup}
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            Get Started Free
          </m.button>
          <m.button
            className="btn-cta-secondary"
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            Download App
          </m.button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;